import { useStore } from '../store/store';
import { useEffect } from 'react';
// import PullToRefresh from 'pulltorefreshjs';

const useAppScrollEffect = () => {
  const { utilsStore } = useStore();

  useEffect(() => {
    if (utilsStore.isLockScroll) {
      const handleScrollbar = () => {
        window.scrollTo({ top: utilsStore.lockScrollY });
      };

      window.addEventListener('scroll', handleScrollbar, { capture: true });

      return () => {
        window.removeEventListener('scroll', handleScrollbar, { capture: true });
      };
    } else if (
      typeof utilsStore.returnToPosition === 'number' &&
      utilsStore.isLockScroll !== null
    ) {
      window.scrollTo({ top: utilsStore.returnToPosition });
    }
  }, [utilsStore.isLockScroll, utilsStore.returnToPosition]);

  // This use effect enabled pull to refresh behaviour with posible custom functions to refresh data
  // useEffect(() => {
  //   PullToRefresh.init({
  //     onRefresh: utilsStore.refreshPage,
  //     distThreshold: 51,
  //     distMax: 52,
  //     distReload: 52
  //   });

  //   return () => {
  //     PullToRefresh.destroyAll();
  //   };
  // }, []);
};

export default useAppScrollEffect;
